
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.004 9.534a7.79 7.79 0 016.535 3.526c.209.292.153.67-.101.87l-.074.049c-.28.233-.699.146-.932-.18-1.163-1.822-3.225-2.928-5.428-2.928a6.507 6.507 0 00-5.321 2.716l-.144.208c-.172.301-.542.402-.81.243l-.07-.05c-.32-.182-.42-.595-.23-.926 1.487-2.21 3.936-3.528 6.575-3.528zm0-8.2a3.73 3.73 0 013.74 3.738 3.73 3.73 0 01-3.74 3.739 3.73 3.73 0 01-3.738-3.739 3.73 3.73 0 013.738-3.739zm0 1.336a2.392 2.392 0 00-2.402 2.402 2.392 2.392 0 002.402 2.402 2.392 2.392 0 002.402-2.402A2.392 2.392 0 008.004 2.67z"}})])
          )
        }
      }
    